/** ดาบชาดคลั่งไฟ (fx 'bloodstorm'): a whirlwind of blood, crimson cuts through everyone, red lightning. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('bloodstorm', (host) => ({
  skill: ({ src, s, sx, sy }) => {
    const r = (s.aoe ?? 3) * 22;
    host.swingArc(src, 'spin', '200,20,30', 1.6);
    host.swingArc(src, 'spin', '255,160,160', 1.1);
    host.fx.push({ type: 'shock', x: sx, y: sy, t: 0, life: 0.6, r, col: '200,20,30' });
    host.fx.push({ type: 'sigil', x: sx, y: sy, t: 0, life: 1, r: r * 0.8, col: '180,10,20' });
    for (let k = 0; k < 6; k++) {
      const a = (k / 6) * Math.PI * 2 + R();
      host.fx.push({
        type: 'cut',
        x: sx + Math.cos(a) * r * 0.2,
        y: sy - 14 + Math.sin(a) * r * 0.1,
        t: -k * 0.05,
        life: 0.25,
        x1: sx + Math.cos(a) * r,
        y1: sy - 14 + Math.sin(a) * r * 0.5,
        col: '220,30,40',
      });
      host.fx.push({
        type: 'zap',
        x: sx,
        y: sy - 60,
        t: -k * 0.06,
        life: 0.18,
        x1: sx + Math.cos(a) * r * 0.8,
        y1: sy + Math.sin(a) * r * 0.4,
        col: '255,40,50',
        seed: R() * 999,
      });
    }
    host.bloodSpray(sx, sy - 16, 60, 140);
    host.impact('200,20,30', 0.4, 0.9, 7);
    host.sfx.boom();
  },
}));
